import ControlBar from './ControlBar';
import Controls from './Controls';
import Scrubber from './Scrubber';
import Time from './Time';
import ToggleIcon from './ToggleIcon';
import Video from './Video';

export default Video;
export { Controls, ControlBar, Scrubber, Time, ToggleIcon };
